import { useQuery } from '@tanstack/react-query';
import { ProcessedHeartRateResponse } from '@repo/shared/dtos/devices/HeartRateDto';

interface UseOuraHeartRateReturn {
  heartRateData: ProcessedHeartRateResponse | null;
  isLoading: boolean;
  error: Error | null;
  refetch: () => Promise<void>;
}

const BASE_URL = '/api/oura/heartrate';

export const useOuraHeartRate = (limit = 100, date?: Date): UseOuraHeartRateReturn => {
  const {
    data: heartRateData = null,
    isLoading,
    error,
    refetch: queryRefetch,
  } = useQuery({
    queryKey: ['oura', 'heartrate', limit, date?.toISOString()],
    queryFn: async () => {
      const params = new URLSearchParams({
        limit: limit.toString(),
        ...(date && { date: date.toISOString() }),
      });

      const response = await fetch(`${BASE_URL}/processed?${params}`);

      if (!response.ok) {
        throw new Error('Failed to fetch heart rate data');
      }

      return response.json();
    },
  });

  const refetch = async () => {
    await queryRefetch();
  };

  return {
    heartRateData,
    isLoading,
    error,
    refetch,
  };
};
